import {
  createBrowserRouter,
  createRoutesFromElements,
  Outlet,
  Route,
  RouterProvider,
} from 'react-router-dom';
import LandgReferral from './components/pages/GenericReferral';
import { ReferredGenericPage } from './components/pages/ReferredGenericPage';
import { ScrollToTop } from '@percihealth/react';
import GenericReferralLoginPage from './components/pages/GenericReferralLoginPage';
import Layout from './components/shared/Layout/Layout';
import {
  AskForRightsPage,
  AuthProvider,
  PrivateElement,
} from '@percihealth/react-auth';
import firebaseApp from './firebase';
import { FirebaseProvider } from '@packages/web-shared';

export default function App() {
  const router = createBrowserRouter(
    createRoutesFromElements(
      <Route
        path="/"
        element={
          <Layout>
            <ScrollToTop />
            <Outlet />
          </Layout>
        }
      >
        <Route
          path="/"
          element={
            <PrivateElement>
              <LandgReferral />
            </PrivateElement>
          }
        />
        <Route
          path="referred"
          element={
            <PrivateElement>
              <ReferredGenericPage />
            </PrivateElement>
          }
        />
        <Route path="/login" element={<GenericReferralLoginPage />} />
        <Route path="/ask-for-rights" element={<AskForRightsPage />} />
      </Route>,
    ),
  );

  return (
    <AuthProvider firebaseApp={firebaseApp}>
      <FirebaseProvider firebaseApp={firebaseApp}>
        <RouterProvider router={router} fallbackElement={<p>Loading...</p>} />
      </FirebaseProvider>
    </AuthProvider>
  );
}
